import Carousel from 'better-react-carousel'
import BittersCard from "../../BittersCard.client";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import CookingCard from "../recipes/CookingCard.client";
import { makeKey } from "../../../utilities/helpers";

// TODO: combine with bitterscarousel for 1 data point
const recipes = [
  {
    'name': 'Orange',
    'image': '/images/cooking/balsamic.jpg',
    'flavor': 'bright',
    'description': 'Use in Balsamic Vinaigrette, Orange Vinaigrette, Hollandaise, Pico de Gallo',
    'link': '/shop/products/orange'
  },
  {
    'name': 'Grapefruit Hibiscus',
    'image': '/images/cooking/tzatziki.jpg',
    'flavor': 'zesty',
    'description': 'Sesame Ginger Dressing, Tzatziki, Raspberry Vinaigrette, Remoulade',
    'link': '/shop/products/grapefruit-hibiscus',
  },
  {
    'name': 'Chipotle Cacao',
    'image': '/images/cooking/buffalo.jpg',
    'flavor': 'spicy',
    'description': 'Chili Lime Vinaigrette, Buffalo Sauce, Birria Consomé',
    'link': 'shop/products/chipotlecacao',
  },
  {
    'name': 'Bolivar',
    'image': '/images/cooking/nuoc-cham.jpg',
    'flavor': 'aromatic',
    'description': 'Garlic & Herb Vinaigrette, Honey Mustard, Nước Chấm',
    'link': '/shop/products/bolivar',
  },
  {
    'name': 'Ginger Allspice',
    'image': '/images/cooking/chimichurri.jpg',
    'flavor': 'zesty',
    'description': 'Tikka Masala, Chimichurri, Texas BBQ Sauce, Cochinita Pibil Marinade',
    'link': '/shop/products/ginger-allspice',
  },
  {
    'name': 'Cherry Bark Vanilla',
    'image': '/images/cooking/peanut-sauce.jpg',
    'flavor': 'robust',
    'description': 'Thai Peanut Sauce, Ponzu Sauce, Salsa di Noci',
    'link': '/shop/products/ginger-allspice',
  },
  {
    'name': 'Blackstrap',
    'image': '/images/cooking/marinara.jpg',
    'flavor': 'smoky',
    'description': 'Carolina BBQ Sauce, Korean BBQ Marinade, Marinara',
    'link': '/shop/products/blackstrap',
  },
  {
    'name': 'Root Beer',
    'image': '/images/cooking/kcbbq.jpg',
    'flavor': 'earthy',
    'description': 'Kansas City BBQ Sauce, Maple Vinaigrette, Pork Chop Marinade',
    'link': '/shop/products/root-beer',
  },
  {
    'name': 'Trinity',
    'image': '/images/cooking/yogurt-herb-sauce.jpg',
    'flavor': 'all-purpose',
    'description': 'Pineapple Salsa, Italian Vinaigrette, Yogurt-Herb Sauce',
    'link': '/shop/products/trinity',
  },
]


// TODO: seperate arrows into components
const arrowLeft = () => (
  <span type="prev" className="absolute left-3 lg:left-0 z-10 flex items-center justify-center w-10 h-10 transition duration-300 transform rotate-45 -translate-y-1/2 rounded-none top-1/2 bg-dark ring-offset-2 ring-1 ring-gold hover:bg-gold ring-offset-paper">
    <HiArrowLeft className="w-5 h-5 transform -rotate-45 text-paper" />
  </span>
)
const arrowRight = () => (
  <span type="prev" className="absolute right-3 lg:right-0 z-10 flex items-center justify-center w-10 h-10 transition duration-300 transform rotate-45 -translate-y-1/2 rounded-none top-1/2 bg-dark ring-offset-2 ring-1 ring-gold hover:bg-gold ring-offset-paper">
  <HiArrowRight className="w-5 h-5 transform -rotate-45 text-paper" />
  </span>
)

const breakPoints = [
  {
    breakpoint: 767,
    cols: 1,
    rows: 1,
    gap: 10,
    loop: true,
    hideArrow: false
  },
  {
    breakpoint: 868,
    cols: 2,
    rows: 1,
    gap: 0,
    loop: true,

  },
  {
    breakpoint: 1200,
    cols: 3,
    rows: 1,
    gap: 10,
    loop: true
  },
  {
    breakpoint: 1650,
    cols: 4,
    rows: 1,
    gap: 10,
    loop: true
  },
]

export default function BakingCarousel(){






  return(
    <div className="pb-20">
      <Carousel
      responsiveLayout={breakPoints}
       cols={5} rows={1} gap={16} loop arrowLeft={arrowLeft} mobileBreakpoint={450} arrowRight={arrowRight} hideArrow={false}
       >
        {recipes.map(bitters => {
          return(
            <Carousel.Item key={makeKey(bitters.name)}>
              <CookingCard bitters={bitters}/>
            </Carousel.Item>
          )
          })}
      </Carousel>
    </div>
  )
}